import { Component, inject, OnDestroy, OnInit, Renderer2, signal, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { APIService } from '@core/services';
import { PatientService } from '@core/services/patient.service';
import { TableComponent, TableOptions } from '@shared/components';
import { VaccinationEuvac } from '@core/classes/tables/vaccination-euvac';
import { AddVaccinationComponent } from '@modules/cy/patient/euvac/components/vaccinations/actions/add-vaccination/add-vaccination.component';
import { VaccinationStatusActionComponent } from '@modules/cy/patient/euvac/components/vaccinations/actions/vaccination-status-action/vaccination-status-action.component';

@Component({
  selector: 'ncp-vaccinations',
  imports: [TableComponent],
  templateUrl: './vaccinations.component.html',
  styleUrl: './vaccinations.component.scss',
})
export class VaccinationsComponent implements OnInit, OnDestroy {
  @ViewChild('vaccinations') public vaccinationsEl!: TableComponent<VaccinationEuvac>;

  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<VaccinationEuvac>>(
    new TableOptions<VaccinationEuvac>({
      id: 'vaccinations',
      type: 'Vaccinations',
      interface: VaccinationEuvac,
      autoLoadData: false,
      ignoreColumns: [
        'patient_id',
        'user_id',
        'drug_id',
        'barcode',
        'code',
        'code_system',
        'code_system_name',
        'code_system_version',
        'packnr',
        'diseases',
      ],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData();
  }

  protected getData = () => {
    this.apiService
      .call({
        path: '/get-vaccinations-euvac',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          status: -1,
        },
      })
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        if (response && response.status === 1) {
          this.options.set(
            new TableOptions<VaccinationEuvac>({
              id: 'vaccinations',
              type: 'Vaccinations',
              interface: VaccinationEuvac,
              data: response.data,
              autoLoadData: false,
              ignoreColumns: [
                'patient_id',
                'user_id',
                'drug_id',
                'barcode',
                'code',
                'code_system',
                'code_system_name',
                'code_system_version',
                'packnr',
                'diseases',
              ],
              actionsComponent: VaccinationStatusActionComponent,
              extraComponent: AddVaccinationComponent,
              pagination: {
                itemsPerPage: 10,
                pageNumber: 1,
                totalItems: response.data.length,
              },
              renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
                const data = row as VaccinationEuvac;
                if (item === 'status') {
                  td.innerHTML = '';
                  const iEl = this.renderer2.createElement('h2');
                  if (data.status === 1) {
                    this.renderer2.addClass(iEl, 'bi');
                    this.renderer2.addClass(iEl, 'bi-eye');
                    this.renderer2.addClass(iEl, 'text-primary');
                  } else {
                    this.renderer2.addClass(iEl, 'bi');
                    this.renderer2.addClass(iEl, 'bi-eye-slash');
                    this.renderer2.addClass(iEl, 'text-secondary');
                  }
                  this.renderer2.appendChild(td, iEl);
                }
              },
              searchComponent: null,
            })
          );
        }
      });
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
